import { useEffect } from 'react';
import { recurlyApiKeyRow, recurlyApiKeyEu } from '@saucelabs/sl-util-config';
import { constants } from '@saucelabs/sl-module-user';
import PropTypes from 'prop-types';

import { RECURLY_JS_CONFIGURATION } from '../constants';

const RECURLY_JS_CDN_URL = 'https://js.recurly.com/v4/recurly.js';

const configureRecurlyJS = (apiKey) => {
  recurly.configure({
    ...RECURLY_JS_CONFIGURATION,
    publicKey: apiKey,
  });
};

// Checks if recurly.js was already added to the DOM (by another use of this component)
const isRecurlyAlreadyLoaded = () => {
  for (const script of document.scripts) { // eslint-disable-line no-restricted-syntax
    if (script.src === RECURLY_JS_CDN_URL) {
      return true;
    }
  }
  return false;
};

const RecurlyHelper = ({ afterLoad, instance }) => {
  const onLoad = () => {
    const apiKey = instance === constants.RECURLY_INSTANCES.EU ? recurlyApiKeyEu : recurlyApiKeyRow;

    configureRecurlyJS(apiKey);
    afterLoad?.();
  };

  useEffect(() => {
    if (!isRecurlyAlreadyLoaded()) {
      // recurly dependency added dynamically to the head of the html
      const recurlyScript = document.createElement('script');
      recurlyScript.setAttribute('src', RECURLY_JS_CDN_URL);
      recurlyScript.onload = onLoad;
      document.head.appendChild(recurlyScript);
    } else {
      onLoad();
    }
  }, []);

  return null;
};

RecurlyHelper.propTypes = {
  afterLoad: PropTypes.func,
};

RecurlyHelper.defaultProps = {
  afterLoad: null,
};

export default RecurlyHelper;
